import React, {Suspense} from 'react';
import {observer} from "mobx-react-lite";
import commonPopupStore from "../../common/popup/store/CommonPopupStore";
import PageLoading from "../../components/loading";

const CommonModalComponent: React.FC = () => {
    return (
        <>
            {commonPopupStore.popupList.map(item => item.element)}
        </>
    )
};

export default observer(CommonModalComponent);